import paper from 'paper';
import { mapMutations, mapGetters } from 'vuex';
import vtooltip from './vtooltip';
import Clickoutside from '../../../directives/clickoutside';

export default {
    mixins: [vtooltip],
    directives: { Clickoutside },
    model: {
        prop: 'selected',
        event: 'update',
    },
    props: {
        selected: {
            type: String,
            required: true,
        },
    },
    // template:
    //   "<div><i v-tooltip.right='tooltip' class='fa fa-x' :class='icon' :style='{ color: iconColor }' @click='click'></i><br></div>",

    render(h) {
        const directives = [
            {
                name: 'tooltip',
                value: { content: this.tooltip, placement: 'bottom' },
            },
        ];
        const onEvent = {
            click: this.click,
        };
        let el = null;
        if (this.iconImage) {
            el = h('img', {
                directives,
                on: onEvent,
                attrs: {
                    src: this.iconSrc,
                },
                class: 'toolbar-icon',
            });
        } else {
            el = h('i', {
                class: ['fa fa-x', this.icon],
                style: {
                    color: this.iconColor,
                },
                // 使用自定义指令
                directives,

                on: onEvent,
            });
        }

        let contentEl = [el];
        if (this.$options.name === 'SelectTool') {
            let contextMenuEl = null;
            contextMenuEl = h(
                'div',
                {
                    ref: 'contextmenu',
                    class: 'custom-contextmenu',
                    style: this.contextmenuStyle,
                    directives: [
                        {
                            name: 'show',
                            value: this.contextmenuVisible,
                        },
                        {
                            name: 'clickoutside',
                            value: this.closeContextmenu,
                        },
                    ],
                },
                [
                    h('ul', {}, [
                        h(
                            'li',
                            {
                                on: {
                                    click: () => {
                                        this.handleMenuCommand('delete');
                                    },
                                },
                            },
                            '点击删除',
                        ),
                    ]),
                ],
            );
            contentEl.push(contextMenuEl);
        }
        return h(
            'div',
            {
                class: 'annotator-tool-item',
                style: {
                    cursor: this.isDisabled ? 'not-allowed' : 'default',
                },
            },
            contentEl,
        );
    },
    data() {
        return {
            tool: null,
            enabled: false,
            cursor: 'default',
            toolTipText: {
                // 工具提示
                zh: '', // 中文
                en: '', // 英文
            },
            color: {
                enabled: 'white',
                active: '#2ecc71',
                disabled: 'gray',
                toggle: 'red',
            },
        };
    },
    methods: {
        onMouseMove() {},
        onMouseDown() {},
        onMouseDrag() {},
        onMouseUp() {},
        click() {
            this.update();
        },
        update() {
            if (this.isDisabled) return;

            const componentName = this.$options.componentName || this.$options.name;
            this.$emit('update', this.name);
            const canvasEl = this.tool.view.getContext().canvas;
            if (componentName === 'PolygonTool' || componentName === 'SelectTool') {
                // 阻止系统右键默认菜单
                canvasEl.oncontextmenu = function () {
                    return false;
                };
            } else {
                canvasEl.oncontextmenu = null;
            }
        },
        setPreferences() {},
        setHasPath() {
            this.$nextTick(() => {
                let currentAnnotationComponent = this.$parent.currentAnnotation;
                let flag = false;
                if (currentAnnotationComponent) {
                    flag = currentAnnotationComponent.hasChildren;
                }
                this.setCurrentAnnotatorHashPath(flag);
            });
        },
        ...mapMutations('annotator', ['setCurrentAnnotatorHashPath']),
    },
    computed: {
        isActive() {
            if (this.selected == this.name) {
                this.$emit('setcursor', this.cursor);
                return true;
            }
            return false;
        },
        iconColor() {
            if (this.isDisabled) return this.color.disabled;

            if (this.isToggled) return this.color.toggle;
            if (this.isActive) return this.color.active;

            return this.color.enabled;
        },
        iconSrc() {
            // if (this.isDisabled) return this.color.disabled

            if (this.isToggled) return this.color.toggle;
            if (this.isActive) return this.iconImageActive;

            return this.iconImage;
        },
        isDisabled() {
            return false;
        },
        tooltip() {
            let text = this.name;

            let zhText = this.toolTipText.zh;
            let enText = this.toolTipText.en;
            let finishZh = this.toolTipText.finish_zh;
            // let finish_en = this.toolTipText.finish_en;
            if ((zhText !== undefined && zhText !== '') || (enText !== undefined && enText !== '')) {
                text = zhText || enText;
            }
            if (this.isDisabled) {
                if (this.currentAnnotatorHashPath) {
                    text += '\n(一个事件或者一帧只能画一个标注)';
                    return text;
                }
                text += '\n(选择一个事件来激活该工具)';
                return text;
            }
            if (finishZh) {
                text += `,\n${finishZh}`;
            }

            return text;
        },
        ...mapGetters('annotator', ['currentAnnotatorHashPath']),
    },
    watch: {
        isActive(active) {
            if (active) {
                this.tool.activate();
            }
        },
        isDisabled(disabled) {
            if (disabled && this.isActive) {
                this.$emit('update', 'Select');
            }
        },
        '$parent.current': {
            handler() {
                // this.setHasPath();
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.tool = new paper.Tool();

        this.tool.onMouseDown = this.onMouseDown;
        this.tool.onMouseDrag = this.onMouseDrag;
        this.tool.onMouseMove = this.onMouseMove;
        this.tool.onMouseUp = this.onMouseUp;
    },
};
